export default "__VITE_ASSET__C1Vf8lz___"